module.exports = __webpack_public_path__ + "img/hourglass_2_fill.d62e689f.svg";